import React from 'react';
import PropTypes from 'prop-types';
import FormattedCurrency from '../../components/formatted-currency';

const Rate = ({ value, code }) => {
  if (!(value && code)) {
    return null;
  }
  return <FormattedCurrency currencyCode={code} value={value} />;
};

Rate.propTypes = {
  value: PropTypes.number,
  code: PropTypes.string,
};

export default Rate;
